import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RecentTicket } from 'src/app/models/core/recent-ticket.model';
@Component({
  selector: 'app-top-sold-tickets',
  templateUrl: './top-sold-tickets.component.html',
  styleUrls: ['./top-sold-tickets.component.scss'],
  standalone: false
})
export class TopSoldTicketsComponent {

  @Input() tickets: RecentTicket[] = [];
  @Input() loading: boolean = false;
  @Input() onTicketDeleted?: () => void;

  constructor(
    private router: Router,
  ) { }

  goToAllSoldTickets(): void {
    this.router.navigate(['/event-sales/multi-event-tickets']);
  }

}

